import script from "./comprehensive-order-model.vue?vue&type=script&lang=tsx&setup=true"
export * from "./comprehensive-order-model.vue?vue&type=script&lang=tsx&setup=true"

const __exports__ = script;

export default __exports__